import { render, staticRenderFns } from "./ColaboradoresLista.vue?vue&type=template&id=33819660&"
import script from "./ColaboradoresLista.vue?vue&type=script&lang=js&"
export * from "./ColaboradoresLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports